/** A `/image` reply: the image, with its prompt as a quiet caption. */

import type { CardProps } from './types';
import { GeneratedImageView, isFresh } from './GeneratedImageView';

export function ImageMessage({ message }: CardProps) {
  if (message.body.kind !== 'image') return null;
  const { fileId, prompt, width, height } = message.body;
  return (
    <GeneratedImageView fileId={fileId} prompt={prompt} width={width} height={height} fresh={isFresh(message.createdAt)} />
  );
}
